/** CoStar.Api.ConsumerUserData.ExternalEnrollment.ExternalEnrollmentEntityType */
export var ExternalEnrollmentEntityType;
(function (ExternalEnrollmentEntityType) {
    ExternalEnrollmentEntityType[ExternalEnrollmentEntityType["None"] = 0] = "None";
    ExternalEnrollmentEntityType[ExternalEnrollmentEntityType["Listing"] = 1] = "Listing";
    ExternalEnrollmentEntityType[ExternalEnrollmentEntityType["PMC"] = 2] = "PMC";
    ExternalEnrollmentEntityType[ExternalEnrollmentEntityType["CoStarContact"] = 3] = "CoStarContact";
    ExternalEnrollmentEntityType[ExternalEnrollmentEntityType["Property"] = 4] = "Property";
    ExternalEnrollmentEntityType[ExternalEnrollmentEntityType["ApartmentUser"] = 5] = "ApartmentUser";
})(ExternalEnrollmentEntityType || (ExternalEnrollmentEntityType = {}));
